// src/services/createAuthAxiosInstance.ts
import axios, {AxiosRequestConfig, AxiosResponse, AxiosError, InternalAxiosRequestConfig} from 'axios';
import {useAuthStore} from '../store/AuthStore';
import Keychain from 'react-native-keychain';

const createAuthAxiosInstance = () => {
  let config: AxiosRequestConfig = {
    baseURL: process.env.API_AUTH_URL,
    timeout: 30000, 
  };

  const instance = axios.create(config);

  instance.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
      const token = useAuthStore.getState().token;
      if(token != '')
        config.headers = {...config.headers, Authorization: `Bearer ${token}`};
      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response: AxiosResponse) => {
      if (response.data?.errors && response.data?.errors.length) {
        throw {
          message: response.data.errors[0],
        };
      } else {
        return response;
      }
    },
    async (error: AxiosError) => {
      const keychainCredentials = await Keychain.getGenericPassword();
      const originalRequest = error?.config;
      
      // if (error.config) {
      //   console.log(error)
      //   console.error(`Erro na requisição: ${error.config.method?.toUpperCase()} ${error.config.url} ${error.config.baseURL}`);
      // }
      /*
      if(error.response?.status === 401 && error.config?.url === 'v1/auth/refreshToken') {
        throw new Error('Erro ao renovar o token');
      }
    
      */
      if (error.response?.status === 401) {
        useAuthStore.setState({ token: null });
        return new Promise(() => {});
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

export default createAuthAxiosInstance;
